import { createSelector } from 'reselect';
import { isEmpty, cloneDeep } from 'lodash';

const categoryFacetListSelector = state => state.list;
const categoryFacetItemSelector = state => state.list;
const categoryOrigFacetItemSelector = state => state.origList;
const categoryFacetRootSelector = state => state;

const mapFacetsList = (list) => {
  const clonnedList = cloneDeep(list);
  const virtualFacets = !isEmpty(clonnedList)
    && !isEmpty(clonnedList[0].facetsList)
    ? Object.keys(clonnedList[0].facetsList).map(key => ({
      groupedValues: clonnedList[0].groupedValues,
      ...clonnedList[0].facetsList[key],
    }))
    : [];
  return virtualFacets;
};

const origListSelector = createSelector(
  categoryOrigFacetItemSelector,
  origList => (!isEmpty(origList)
    ? mapFacetsList(origList)
    : []),
);

const listSelector = createSelector(
  categoryFacetListSelector,
  list => (!isEmpty(list)
    ? mapFacetsList(list)
    : []),
);

const itemSelector = createSelector(
  categoryFacetItemSelector,
  item => (!isEmpty(item) ? ({
    ...[...item].shift(),
  }) : {}),
);

export const categoryFacetSelector = createSelector(
  listSelector,
  origListSelector,
  itemSelector,
  categoryFacetRootSelector,
  (list, origList, item, state) => ({
    ...state, list, origList, item,
  }),
);

export default {
  categoryFacetSelector,
};
